module.exports = __webpack_public_path__ + "media/1700-2_YR_2022_Malware.8d28e0b6.mp4";